import React from 'react';

export const Dashboard = ({ children }) => (
  <div className="nk-app-root">
    {/* <Sidebar /> */}

    {children}
  </div>
);
